// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { urlLinksResponseSchema } from '@/url-link/api/types';

/**
 * Requests a collection of URL links for a purchase order from the remote API.
 *
 * @param key - The key of the purchase order for which to request URL links.
 */
export async function getPurchaseOrderURLLinks(key: string) {
  const path = `/v1/purchase-order/${key}/url-link`;
  const response = await api.get(path);

  return parseResponse(urlLinksResponseSchema, response.data, {
    schemaName: 'PurchaseOrderURLLinks',
    endpoint: path,
  });
}
